import { Plus } from "lucide-react";
import { LeadSourcesTable } from "@/components/features/settings/defaults/lead-sources/LeadSourcesTable";
import { Button, Text } from "@/components/ui";
import { useUser } from "@/components/UserProvider";
import {
  ACTION_PERMISSION_KEYS,
  ACTION_PERMISSION_VALUES,
} from "@/lib/data/static/permissionOptions";
import { useState } from "react";

export default function LeadSourcesDefaults({
  title = "Lead sources",
  addButtonLabel = "Add lead source",
}: {
  title?: string;
  addButtonLabel?: string;
} = {}) {
  const { hasActionPermission } = useUser();
  const [isAddingLeadSource, setIsAddingLeadSource] = useState(false);

  const canCreate = hasActionPermission(
    ACTION_PERMISSION_KEYS.leadSource,
    ACTION_PERMISSION_VALUES.create,
  );

  return (
    <div className="w-full">
      <div className="mb-8 flex flex-col gap-4 sm:flex-row sm:items-start sm:justify-between">
        <div className="gap-y-1">
          <Text variant="title">{title}</Text>
        </div>
        {canCreate ? (
          <Button
            variant="foreground"
            size="md"
            className="shrink-0"
            onClick={() => {
              setIsAddingLeadSource(true);
            }}
          >
            <Plus className="h-4 w-4" aria-hidden="true" />
            {addButtonLabel}
          </Button>
        ) : null}
      </div>
      <LeadSourcesTable
        isAdding={isAddingLeadSource}
        setIsAdding={setIsAddingLeadSource}
      />
    </div>
  );
}
